﻿import React, { useState, useEffect } from 'react';

import { InfoWindow } from '@react-google-maps/api';
import { search } from '../Endpoints'

const InfoWindowWidget = ({ cityPageContext, keyboardEvent, selectedPlace, anchor, onClose }) => {
  const lang = {
    ...cityPageContext.localization.inputs,
    ...cityPageContext.localization.headings,
    ...cityPageContext.localization.filter
  };

  const serviceList = new Array();

  if (selectedPlace.indoor) {
    serviceList.push({
      id: "type",
      text: lang.info.indoor.replaceAll('&shy;', '\xAD')
    });
  }

  if (selectedPlace.outdoor) {
    serviceList.push({
      id: "type",
      text: lang.info.outdoor.replaceAll('&shy;', '\xAD')
    });
  }

  if (selectedPlace.info && selectedPlace.info.heated) {
    serviceList.push({
      id: "heated",
      text: lang.info.heated.replaceAll('&shy;', '\xAD')
    }); 
  }

  if (selectedPlace.info && (selectedPlace.info.maxVehicleHeight && selectedPlace.info.maxVehicleHeight > 200 || !selectedPlace.info.maxVehicleHeight)) {
    serviceList.push({
      id: "maxVehicleHeight",
      text: lang.info.maxVehicleHeight.replaceAll('&shy;', '\xAD')
    });
  }

  if (selectedPlace.services && selectedPlace.services.includes('electricChargingPoint')) {
    serviceList.push({
      id: "electricChargingPoint",
      text: lang.services.electricchargingpoint.replaceAll('&shy;', '\xAD')
    });
  }

  if (selectedPlace.services && selectedPlace.services.includes('disabled')) {
    serviceList.push({
      id: "disabled",
      text: lang.services.disabled.replaceAll('&shy;', '\xAD')
    });
  }

  if (selectedPlace.hasStp) {
    serviceList.push({
      id: "stp",
      text: lang.info.STP.replaceAll('&shy;', '\xAD')
    });
  }

  if (selectedPlace.hasLtp) {
    serviceList.push({
      id: "ltp",
      text: lang.info.LTP.replaceAll('&shy;', '\xAD')
    });
  }

  return (
    <InfoWindow anchor={anchor} onCloseClick={() => onClose(false)}>
      <div className={['citypage__map__info', !keyboardEvent ? "citypage__map__info--nofocus" : null].join(' ')}>
        <h3><a href={selectedPlace.url} onClick={(e) => { if (!selectedPlace.url) e.preventDefault() }}>{selectedPlace.Name}</a></h3>
        <p>{selectedPlace.Address.street}{selectedPlace.Address.number && ` ${selectedPlace.Address.number}`}, {selectedPlace.Address.postCode} {selectedPlace.Address.city}</p>

        {serviceList.length > 0 && (
          <p className="services">
            {serviceList.map(service => (
              <span key={service.id}>{service.text}</span>
            ))}
          </p>
        )}
      </div>
    </InfoWindow>
  )
}

export default InfoWindowWidget;
